import * as React from "react"

export default function CloseIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M10 8.822l4.125-4.125 1.178 1.178L11.178 10l4.125 4.125-1.178 1.178L10 11.178l-4.125 4.125-1.179-1.178L8.821 10 4.696 5.875l1.179-1.178L10 8.822z"
        fill={props.fill}
      />
    </svg>
  )
}
